import LocalStorageCache from 'lyjs/es/cache/LocalStorageCache'

import {TOKEN_CACHE_KEY} from 'services/constants'

export default new LocalStorageCache(TOKEN_CACHE_KEY)
